"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUrlService = /** @class */ (function () {
    function BaseUrlService() {
    }
    BaseUrlService.prototype.getListUrl = function () {
        return this.baseURL;
    };
    BaseUrlService.prototype.getListUrlForField = function (fieldName, id) {
        var filter = {};
        filter[fieldName] = id;
        return this.getListUrlForFields(filter);
    };
    BaseUrlService.prototype.getListUrlForFields = function (fields) {
        var url = Object.keys(fields).reduce(function (newurl, fieldName) {
            return newurl + ("&" + fieldName + "=" + fields[fieldName]);
        }, this.baseURL);
        url = url.replace(/&/, "?");
        return url;
    };
    BaseUrlService.prototype.getDeleteUrl = function (id) {
        id = encodeId(id);
        return this.baseURL + "/" + id;
    };
    BaseUrlService.prototype.getLoadUrl = function (id) {
        id = encodeId(id);
        return this.baseURL + "/" + id;
    };
    BaseUrlService.prototype.getSaveUrl = function () {
        return this.baseURL;
    };
    BaseUrlService.prototype.getUpdateUrl = function (id) {
        id = encodeId(id);
        return this.baseURL + "/" + id;
    };
    BaseUrlService.prototype.getFieldUrl = function (id, fieldName) {
        id = encodeId(id);
        return this.baseURL + "/" + id + "/" + fieldName;
    };
    /**
     * @deprecated please use getFieldUrl instead
    */
    BaseUrlService.prototype.getFileUploadUrl = function (id, fieldName) {
        return this.getFieldUrl(id, fieldName);
    };
    /**
     * @deprecated please use getFieldUrl instead
    */
    BaseUrlService.prototype.getFileDownloadUrl = function (id, fieldName) {
        return this.getFieldUrl(id, fieldName);
    };
    BaseUrlService.prototype.getExcelUrl = function (params) {
        if (params === void 0) { params = undefined; }
        if (params) {
            return this.baseURL + ".xlsx?" + new URLSearchParams(params).toString();
        }
        return this.baseURL + ".xlsx";
    };
    return BaseUrlService;
}());
exports.BaseUrlService = BaseUrlService;
function encodeId(id) {
    id = encodeURIComponent("" + id);
    return id;
}
exports.encodeId = encodeId;
//# sourceMappingURL=base.url.service.js.map